<div [ngClass]="[guestAvatarSize, 'guest-avatar']">
  <img src="/assets/icons/guest-avatar.svg" />
</div>
